/**
 * How long a toast stays (Akhil, 2026-09-17: an error vanished before it could be read).
 *
 * A confirmation ("Saved") is glanced at; 2.6s was right for those and stays. A message that
 * reports something went wrong needs reading time — about 10s, longer for a long one, 15s at
 * most — and then goes on its own; hovering holds it, a click dismisses it early.
 */

const FAILURE = /could not|cannot|can't|couldn't|not sent|not saved|not filed|failed|refus|⚠|⛔|error|required|missing|unavailable|rejected/i

export const isFailure = (text: string): boolean => FAILURE.test(text)

/**
 * Milliseconds before the toast hides itself. A failure stays ~10s (Akhil, 2026-09-17: "let it
 * hang on there for a few more sec like 10 sec" — not a sticky box to dismiss); a confirmation
 * 2.6s; either grows with the text, to 15s at most.
 */
export function toastDuration(text: string): number {
  const byLength = Math.round(text.length / 12) * 1000
  const floor = isFailure(text) ? 10000 : 2600
  return Math.min(15000, Math.max(floor, byLength))
}
